export default __webpack_public_path__ + "static/media/ConfigScalyrAgentK8sExplorer.beabad50.md";